import { InjectionToken } from "@angular/core";

import { IModalServiceInstance } from "angular-ui-bootstrap";

export class ModalInstanceClass {
  public instance: IModalServiceInstance = null;

  public setInstance(instance: IModalServiceInstance): void {
    this.instance = instance;
  }
}

export const ModalInstanceToken = new InjectionToken("$uibModalInstanceToken", {
  factory: (): ModalInstanceClass => new ModalInstanceClass(),
});
